import { render, staticRenderFns } from "./Datasets-Selector.vue?vue&type=template&id=cc7faaa8&lang=pug"
import script from "./Datasets-Selector.vue?vue&type=script&lang=ts"
export * from "./Datasets-Selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports